



export const locale = {
    lang: 'en',
    data: {
	'FAVORIS':{
'TITLE':'',
'SEARCH':'Search',

'NAME':'',
'SEARCH_TEXT':'Search for an app or a page',
'NO_SHORTCUTS':'No shortcuts yet!',
'ADD_SHORTCUT':'Click to add/remove shortcut',
}
}
};